import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
import MKBox from "components/MKBox";
//import MKTypography from "components/MKTypography";
//import MKSocialButton from "components/MKSocialButton";

// Material Kit 2 React examples
//import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";

//import DesignBlocks from "pages/Presentation/sections/DesignBlocks";
//import Pages from "pages/Presentation/sections/Pages";
//import Testimonials from "pages/Presentation/sections/Testimonials";
//import Download from "pages/Presentation/sections/Download";

// Presentation page components
//import BuiltByDevelopers from "pages/Presentation/components/BuiltByDevelopers";
import React, { useState, useEffect } from "react";
import { Button, Card, CardContent } from "@mui/material";
// Routes
//import routes from "routes";
// Images
import bgImage from "assets/images/strategia.jpg";
//import { ALL_MUNICIPALITIES } from "queries";
import { useQuery } from "@apollo/client";
import { useLazyQuery } from "@apollo/client";
//import { Link } from "react-router-dom";
import { FIND_INITIATIVES_BY_MUNICIPALITY, FIND_VOTES_BY_MUNICIPALITY } from "queries";
import { useTranslation } from "react-i18next";
/* eslint-disable react/prop-types */
// eslint-disable-next-line
const Initiativespublic = ({ selectedKunta, setSelectedKunta }) => {
  //const Strategy = ({ selectedKunta, setSelectedKunta }) => {
  //console.log(selectedKunta);
  const [t] = useTranslation("common");
  //console.log(setSelectedKunta);
  // eslint-disable-next-line
  const [getInitiatives, result] = useLazyQuery(FIND_INITIATIVES_BY_MUNICIPALITY);
  const [initiatives, setInitiatives] = useState([]);
  const [votes, setVotes] = useState([]);
  //console.log(votes);
  const votessw = useQuery(FIND_VOTES_BY_MUNICIPALITY, {
    pollInterval: 100000,
    variables: { municipality: selectedKunta },
  });
  useEffect(() => {
    let votess = [];
    //console.log(votessw);
    //let municipalitiess = [];
    if (votessw.data) {
      votess = votessw.data.findVotesByMunicipality;
      //setOrgans(organss);
      //console.log(votess);
      //let secs = proposalss.filter((cont) => {
      //return cont.agendaid === meeting;
      //});
      //setProposals(secs);
      setVotes(votess);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [votessw]);
  function voteCount(p) {
    //console.log(p);
    if (votes !== undefined) {
      return votes.filter((a) => a.initiativeid === p).length;
    }
  }
  //const [ideas, setIdeas] = useState([]);
  //console.log(getInitiatives);
  //console.log(result);
  ////console.log(setOrgans);
  const initiativessw = useQuery(FIND_INITIATIVES_BY_MUNICIPALITY, {
    pollInterval: 100000,
    variables: { municipality: selectedKunta, initiativeaccepted: false },
  });

  //let municipalitiess = [];
  /*useEffect(() => {
    let valittu = initiatives.filter(function (el) {
      return el.agendaid === meeting;
    });
    //console.log(valittu);
    setSelected(valittu);
  }, [selectedKunta, initiatives]);*/
  useEffect(() => {
    let initiativess = [];
    //let municipalitiess = [];
    if (initiativessw.data) {
      initiativess = initiativessw.data.findInitiativesByMunicipality;
      //setOrgans(organss);
      //console.log(initiativess);
      //let secs = initiativess.filter((cont) => {
      //return cont.agendaid === meeting;
      //});
      //setinitiatives(secs);
      setInitiatives(initiativess);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [initiativessw, selectedKunta]);
  //municipalitiess=organsw.data.allOrgans
  const handleVote = () => {
    window.confirm("Sinun on kirjauduttava voidaksesi äänestää");
  };
  return (
    <>
      <MKBox
        minHeight="23vh"
        width="100%"
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "2500px 500px",
          backgroundPosition: "top",
          display: "grid",
          placeItems: "center",
        }}
      />
      <br />
      <MKBox pt={0} px={1} mt={6}>
        <Container>
          <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
            <MKTypography
              variant="h2"
              color="dark"
              textAlign="center"
              px={{ xs: 6, lg: 12 }}
              mt={1}
            >
              {t("initiatives.header")}
            </MKTypography>
            <MKTypography
              variant="body1"
              color="dark"
              textAlign="center"
              px={{ xs: 6, lg: 12 }}
              mt={1}
            >
              <br />
              <p>{t("initiatives.text")}</p>
              <br />
              <br />
              {initiatives.map((p, index) => (
                <Card key={index} style={{ marginBottom: "0.5rem" }}>
                  <CardContent
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <MKTypography>
                      {p.organid}: {p.initiativetext}
                    </MKTypography>
                    <Button
                      variant="contained"
                      style={{ color: "white" }}
                      onClick={() => handleVote(p.id)}
                    >
                      👍 {voteCount(p.id)}
                    </Button>
                  </CardContent>
                </Card>
              ))}
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
    </>
  );
};

export default Initiativespublic;
